module.exports = __webpack_public_path__ + "static/media/arrow-down.cc78dde9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/02/assets/arrow-down.svg
// module id = 554
// module chunks = 0